import gql from "graphql-tag";

export const PROCESS_MAIL_SET = gql`
	mutation Process ($mailSetId: UUID!) {
		process (input: {mailSetId: $mailSetId}) {
			success
			errors
		}
	}
`;
